import { render, staticRenderFns } from "./UserStudentProfile.vue?vue&type=template&id=bc26a8fc&"
import script from "./UserStudentProfile.vue?vue&type=script&lang=js&"
export * from "./UserStudentProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserStudentProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports